import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-681e8d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  id: "btn-mas"
}, null, -1))
const _hoisted_3 = { class: "redes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash-alt",
  _mstvisible: "2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-print",
  _mstvisible: "2"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-list",
  _mstvisible: "2"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-mas" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "btn-mas",
    class: "fa fa-cog"
  })
], -1))
const _hoisted_8 = {
  key: 0,
  class: "spin"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "general" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Detalle de Nota de Crédito", -1))
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Entidades")
], -1))
const _hoisted_15 = { class: "grid" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "medico"
}, "Médico:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "medico"
}, "Cliente:", -1))
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Comprobante Fiscal")
], -1))
const _hoisted_20 = { class: "grid" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaPago"
}, "Fecha:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "ncf"
}, "NCF:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "bruto"
}, "NCF Afectado:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "bruto"
}, "Valor:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "subTipo"
}, "Motivo:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Ajuste", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Reenvío", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Pérdida", -1))
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDelete())),
          class: "a red",
          to: ""
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push(`/documentosnc2/${this.$route.params.id}`))),
          class: "a orange",
          to: ""
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "a yellow",
          to: "/documentosnc"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _hoisted_7
    ]),
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_12,
          _createElementVNode("div", null, [
            _createElementVNode("h5", null, "No. " + _toDisplayString(_ctx.formatSecuence(_ctx.documento.no)), 1),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("select", {
                    disabled: "",
                    id: "medico",
                    type: "medico",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.documento.medico) = $event)),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectMedico(_ctx.documento.medico)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicos, (medico, index) => {
                      return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(medico.emisor), 1))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.documento.medico]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("select", {
                    disabled: "",
                    id: "cliente",
                    type: "cliente",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.documento.descCliente) = $event)),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectCliente(_ctx.documento.descCliente)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientes, (cliente, index) => {
                      return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(cliente.descripcion), 1))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.documento.descCliente]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    id: "fechaPago",
                    type: "datetime-local",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.documento.fechaProceso) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.documento.fechaProceso]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "ncf",
                    type: "ncf",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.documento.ncf) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.documento.ncf]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "bruto",
                    type: "number",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.documento.ncfAfecta) = $event)),
                    class: "form-control input-r"
                  }, null, 512), [
                    [_vModelText, _ctx.documento.ncfAfecta]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("input", {
                    id: "bruto",
                    type: "number",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.documento.credito) = $event)),
                    class: "form-control input-r"
                  }, null, 512), [
                    [_vModelText, _ctx.documento.credito]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_25,
                  _withDirectives(_createElementVNode("select", {
                    id: "subTipo",
                    type: "subTipo",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.documento.subTipo) = $event))
                  }, _hoisted_29, 512), [
                    [_vModelSelect, _ctx.documento.subTipo]
                  ])
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
              disabled: !_ctx.documento.fechaProceso || !_ctx.documento.credito
            }, " Actualizar ", 8, _hoisted_30)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}